import React, { useState, useEffect, useCallback } from 'react'
import { COLORES } from '../../../../config/colores'
import * as actions from '../../actions'
import { connect } from 'react-redux'
import { Field, formValueSelector, reduxForm } from 'redux-form'
import { IconButton, Button } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { renderTextField } from '../../../Forms/fieldRenderers'
import PesadoDestareBalanzaManual from '../../components/pesado/PesadoDestareBalanzaManual'
import { FORM_PESO_DESTARE } from '../../../../config/forms'

function PesadoDestareManual (props) {
  const { cpe, handleSubmit } = props
  const [stepPesadoManual, setStepPesadoManual] = useState(0)
  const [pesadoOk, setPesadoOk] = useState(false)
  const [timeLeft, setTimeLeft] = useState(0)

  const reset = useCallback(() => {
    const { change: formChange } = props
    setStepPesadoManual(0)
    formChange('numero', '')
    props.updateConsultaCea(null)
    props.resetConsultaCeaDestare()
    setPesadoOk(false)
  }, [props])

  useEffect(() => {
    const { numero } = props
    const interval = setInterval(async () => {
      if (cpe && cpe.pesoTara && !pesadoOk && timeLeft === 0) {
        setTimeLeft(15)
        setPesadoOk(true)
      }

      if (cpe && cpe.pesoTara) {
        if (pesadoOk && timeLeft > 0) {
          setTimeLeft(timeLeft - 1)
        } else if (pesadoOk && timeLeft === 0) {
          reset()
          props.deleteCpeDestare(numero)
          clearInterval(interval)
        }
      }
    }, [1000])

    return () => {
      clearInterval(interval)
    }
  }, [props, timeLeft, pesadoOk, cpe, reset])

  const altaPesadoManual = (e) => {
    setPesadoOk(true)
    setTimeLeft(15)
    handleSubmit(e)
    setStepPesadoManual(0)
  }

  return (
    <>
      <div
        className='cabecera-pesado-manual'
        style={{
          display: 'flex',
          justifyContent: 'space-around',
          flexDirection: 'row'
        }}
      >
        { stepPesadoManual === 1 && <IconButton onClick={reset}>
          <ArrowBackIcon />
        </IconButton>
        }

        <div>
          <h5>Ingreso de peso manual</h5>
          { stepPesadoManual === 0 && !cpe && <h4 style={{ fontWeight: '600' }} >
                                                        Lea o ingrese la carta de porte
          </h4>
          }

          { stepPesadoManual === 1 && <h4 style={{ fontWeight: '600' }}>
                            Ingrese el peso de tara
          </h4>

          }
        </div>

      </div>

      { stepPesadoManual === 1 && <div className='container-peso-cabezal'>

        <Field
          className='peso-cabezal'
          name='pesoDestare'
          type='text'
          component={renderTextField}
          disabled={false}
          autoFocus
          maxLength={5}
          placeholder='55000'
        />
        <Button
          variant='contained'
          style={{ backgroundColor: COLORES.blue.primary, color: '#ffffff', fontWeight: 'bold' }}
          size='small'
          onClick={altaPesadoManual}
          className='btn-pesado-destare'
        >
                        Confirmar peso
        </Button>
      </div>
      }

      { stepPesadoManual === 0 && <PesadoDestareBalanzaManual
        onBlurInput={props.onBlurInput}
        setStepPesadoManual={setStepPesadoManual}
      />
      }

    </>
  )
}

const selector = formValueSelector(FORM_PESO_DESTARE)

const mapStateToProps = (state) => ({
  numero: selector(state, 'numero'),
  pesoBruto: selector(state, 'pesoDestare')
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_PESO_DESTARE
})

export default withRedux(withReduxForm(PesadoDestareManual))
